import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MetricType } from '../../types';
import { MetricCard } from '../metric-card';
import styles from './styles.module.scss';
var MOBILE_LAYOUT = [[MetricType.AUDIENCE], [MetricType.SENT, MetricType.OPEN_RATE]];
var DESKTOP_LAYOUT = [[MetricType.AUDIENCE, MetricType.SENT, MetricType.OPEN_RATE]];
var MetricsRow = function (_a) {
    var metricTypes = _a.metricTypes, metrics = _a.metrics;
    return (_jsx("div", { className: styles['metrics-row'], children: metricTypes.map(function (metricType) {
            var metric = metrics.get(metricType);
            return _jsx(MetricCard, { title: metric.title, value: metric.value, subtitle: metric.subtitle }, metricType);
        }) }));
};
export var MetricsSection = function (_a) {
    var metrics = _a.metrics;
    return (_jsxs("div", { className: styles['metrics-section'], children: [_jsx("div", { className: styles['mobile-metrics'], children: MOBILE_LAYOUT.map(function (metricTypes) { return (_jsx(MetricsRow, { metricTypes: metricTypes, metrics: metrics }, metricTypes.join('-'))); }) }), _jsx("div", { className: styles['desktop-metrics'], children: DESKTOP_LAYOUT.map(function (metricTypes) { return (_jsx(MetricsRow, { metricTypes: metricTypes, metrics: metrics }, metricTypes.join('-'))); }) })] }));
};
